export function isAdmin(userType) {
  return userType.toLowerCase().includes('admin');
}
